routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.blog', {
      url: __env.routes.blog,
      template: `<blog sh-ctrl="shCtrl"></blog>`
    })
    .state('home.blogCategory', {
      url: __env.routes.blog,
      template: `<blog sh-ctrl="shCtrl"></blog>`
    })
    .state('home.blogTag', {
      url: __env.routes.blogTag,
      template: `<blog sh-ctrl="shCtrl"></blog>`
    })
    .state('home.blogSearch', {
        url: __env.routes.blogSearch,
        template: `<blog sh-ctrl="shCtrl"></blog>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/blog/blog.config.js
 **/